export default __webpack_public_path__ + "static/media/fit-2.0162211e.png";